import React ,{useState , useRef, useEffect} from "react";
import TableRows from "./TableRow";
import TableRows_new from "./TableRow_new";
import TableRows_pur from "./TableRow_pur";
function AddDeleteTableRows_Pur({ itemName , ply , Mrp, calculationtype ,GroupMaster, data , add , edit , deleter , plyquantity, TaxName, CustomerId, IsStockIn,UnitMaster,ItemMaster,GodownMaster, totalSecUnit, secUnitHeader }){



   
  


 

 






    return (
      <div className="table-responsive">
        <table className="table table-bordered" style={{ 
          padding: "0", 
          marginBottom: "10px",
          borderCollapse: "collapse",
          width: "100%",
          border: "1.5px solid black"
        }}>
          <thead>
            <tr style={{
              backgroundColor: "#f8f9fa",
              borderBottom: "1.5px solid black"
            }}>
              <th className="px-2 py-2" style={{ border: "1.5px solid black" }}>Sr.</th>
              <th className="px-2 py-2" style={{ border: "1.5px solid black" }}>Code No.</th>
              <th className="px-2 py-2" style={{ border: "1.5px solid black" }}>Godown</th>
              <th className="px-2 py-2" style={{ border: "1.5px solid black", display: "none" }}>Group Name</th>
              <th className="px-2 py-2" style={{ border: "1.5px solid black" }}>Item Name</th>
              <th className="px-2 py-2" style={{ border: "1.5px solid black" }}>Color</th>
              <th className="px-2 py-2" style={{ border: "1.5px solid black" }}>Unit</th>
              <th className="px-2 py-2" style={{ border: "1.5px solid black" }}>Avail</th>
              <th className="px-2 py-2" style={{ border: "1.5px solid black" }}>Qty</th>
              {!IsStockIn && <th className="px-2 py-2" style={{ border: "1.5px solid black" }}>{secUnitHeader || "Sec Unit"}</th>}
              {IsStockIn ? " " : <>
                <th className="px-2 py-2" style={{ border: "1.5px solid black" }}>Rate</th>
                <th className="px-2 py-2" style={{ border: "1.5px solid black" }}>Disc</th>
                <th className="px-2 py-2" style={{ border: "1.5px solid black" }}>Amount</th>
              </>}
              <th className="px-2 py-2" style={{ border: "1.5px solid black" }}>Del</th>
              <th className="px-2 py-2" style={{ border: "1.5px solid black" }}>Add</th>
            </tr>
          </thead>
          <tbody style={{ border: "1.5px solid black" }}>
            <TableRows_pur
              rowsData={data}
              deleteTableRows={deleter}
              handleChange={edit}
              addTableRows={add}
              itemName= {itemName}
              GroupMaster={GroupMaster}
              UnitMaster={UnitMaster}
              IsStockIn={IsStockIn}
              ItemMaster={ItemMaster}
              GodownMaster={GodownMaster}
              totalSecUnit={totalSecUnit}
              secUnitHeader={secUnitHeader}
              className="border"
            />
            {!IsStockIn && (
              <tr style={{ border: "1.5px solid black", fontWeight: "bold", backgroundColor: "#f2f2f2" }}>
                <td colSpan={9} style={{ border: "1.5px solid black", padding: "8px", textAlign: "right" }}>Total</td>
                <td style={{ border: "1.5px solid black", padding: "8px", textAlign: "center" }}>{totalSecUnit != null && totalSecUnit !== "" ? totalSecUnit : "0"}</td>
                <td colSpan={5} style={{ border: "1.5px solid black", padding: "8px" }}></td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    );
}
export default AddDeleteTableRows_Pur